import { render } from "./option.vue?vue&type=template&id=dd610f56"
import script from "./option.vue?vue&type=script&lang=js"
export * from "./option.vue?vue&type=script&lang=js"

import "./option.vue?vue&type=style&index=0&id=dd610f56&lang=less"
script.render = render

export default script